/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2d49e454"
const script = {}

import exportComponent from "/home/jenkins/agent/workspace/EDUMGD/PRODUCT/FRONTEND-DEPLOY/teach-webs/szpx/szpx-ci/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__